import { map, delay } from "rxjs/operators";
import { Component, OnInit } from "@angular/core";
import { TitleService } from "./services/forms/app-title-service";
import { GlobalService } from "./services/global/global.service";
import { Subscription, Observable, of, fromEvent, merge } from "rxjs";
import { SettingsProvider } from "./services/global/settings-provider.service";
import { environment } from "../environments/environment";
import { UpdateApplication } from "./services/global/update-application.service";
import { AzureAwsSwitchService } from "./authentication/azure-aws-switch.service";
import { LoadingService } from "./services/loading.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [TitleService],
})
export class AppComponent implements OnInit {
  title = "Data Management Application";
  subscription: Subscription;
  public isConnected: Observable<boolean>;

  constructor(
    private titleService: TitleService,
    public globals: GlobalService,
    public azureAws: AzureAwsSwitchService,
    public settingsProvider: SettingsProvider,
    private updateApplication: UpdateApplication,
    private _loading: LoadingService
  ) {
    if (environment.production) this.updateApplication.checkForAppUpdates();
    //this.adalSrv.context.handleWindowCallback();
    this.azureAws.setContext();
  }

  ngOnInit() {
    if (this.isBrowserCompatible()) {
      this.isConnected = merge(
        //Observable.of(navigator.onLine),
        of(navigator.onLine),
        fromEvent(window, "online").pipe(map(() => true)),
        fromEvent(window, "offline").pipe(map(() => false))
      );

      this.isConnected.subscribe(
        (data) => {
          this.globals.isConnected = data;
          console.log("Connected = " + data);
          //if (this.globals.isConnected)
          // this.adalSvc.init(this.settingsProvider.configuration.azurePortalConfig);
        },
        (err) => {
          console.log(
            "app.component.ngOnInit: Error checking connection: " + err
          );
        }
      );
      // this.titleService.currentTitle.subscribe((title) => this.updateTitle(title))
      this.titleService.announceTitleChange(this.title);

      this.checkIfInstalled();
      this.isiOS();
      this.listenToLoading();
      this.isMobile();
    }
  }

  updateTitle(newTitle: string) {
    this.title = newTitle;
  }

  public checkIfInstalled() {
    let windowNavigator: any;
    windowNavigator = window.navigator;

    const isInStandaloneMode = () =>
      "standalone" in window.navigator && windowNavigator.standalone;
    this.globals.isInstalled = isInStandaloneMode();
    console.log("Device is installed (fullscreen):" + isInStandaloneMode());
  }

  public isiOS() {
    var iDevices = [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ];

    this.globals.isiOS = false;

    if (!!navigator.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) {
          this.globals.isiOS = true;
        }
      }
    }

    console.log("app.component.isiOS: Device in use:" + navigator.platform);
    this.globals.device = navigator.platform;
  }

  /**
   * Listen to the loadingSub property in the LoadingService class. This drives the
   * display of the loading spinner.
   */
  listenToLoading(): void {
    this._loading.loadingSub
      .pipe(delay(0)) // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
      .subscribe((loading) => {
        this.globals.loading = loading;
      });
  }

  public isBrowserCompatible(): boolean {
    //Detects if browser is IE or Edge
    const isIEOrEdge: boolean = /msie\s|trident\/|edge\//i.test(
      window.navigator.userAgent
    );
    return !isIEOrEdge;
  }

  public isMobile() {
    let isMobile = {
      Android: () => {
        return navigator.userAgent.match(/Android/i) != null;
      },
      BlackBerry: () => {
        return navigator.userAgent.match(/BlackBerry/i) != null;
      },
      iOS: () => {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null;
      },
      Opera: () => {
        return navigator.userAgent.match(/Opera Mini/i) != null;
      },
      Windows: () => {
        return (
          (navigator.userAgent.match(/IEMobile/i) ||
            navigator.userAgent.match(/WPDesktop/i)) != null
        );
      },
      any: () => {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      },
    };
    this.globals.isMobile = isMobile.any();
  }
}
